import './lordfletchers/style';
import FormStructure from './lordfletchers/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js